<template>
  <div>
    <div class="container td-admin-container">
      <div class="row td-message-row">
        <div class="col s6 offset-s3">
          <h4>{{ message }}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col s12">
          <form @submit.prevent="onSubmitAdd">
            <div class="col s12">
              <div class="row">
                <div class="input-field col s6">
                  <el-select
                      v-model="user_selected"
                      filterable
                      placeholder="User Login"
                      class="select"
                      no-data-text="List is empty"
                      no-match-text="User not found"
                  >
                    <el-option
                        v-for="item in user_list"
                        :key="item.id"
                        :label="item.login"
                        :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="$v.user_selected.$dirty && !$v.user_selected.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
                <div class="input-field col s6">
                  <el-select
                      v-model="currency_selected"
                      filterable
                      placeholder="Currency"
                      class="select"
                      no-data-text="List is empty"
                      no-match-text="Currency not found"
                  >
                    <el-option
                        v-for="item in currency_list"
                        :key="item.id"
                        :label="`${item.currency_abbreviation} (id: ${item.id})`"
                        :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="$v.currency_selected.$dirty && !$v.currency_selected.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s6">
                  <el-select
                      v-model="agent_selected"
                      filterable
                      placeholder="Agent"
                      class="select"
                      no-data-text="List is empty"
                      no-match-text="Agent not found"
                  >
                    <el-option
                        v-for="item in agent_list"
                        :key="item.id"
                        :label="item.agent_name"
                        :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="$v.agent_selected.$dirty && !$v.agent_selected.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                </div>
                <div class="input-field col s6">
                  <input
                    id="min_balance"
                    v-model.trim="min_balance"
                    type="text"
                    :class="{
                      error: $v.min_balance.$dirty && !$v.min_balance.required ||
                             $v.min_balance.$dirty && !$v.min_balance.decimal

                    }"
                  >
                  <label for="min_balance">Min Balance</label>
                  <span v-if="$v.min_balance.$dirty && !$v.min_balance.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                  <span v-if="$v.min_balance.$dirty && !$v.min_balance.decimal" class="helper-text" data-error="wrong" >The field should contain only numbers</span>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s6">
                  <div>
                    <el-select
                        v-model="account_type_selected"
                        filterable
                        placeholder="Account Type"
                        class="select"
                        no-data-text="List is empty"
                        no-match-text="Account Type not found"
                    >
                      <el-option
                          v-for="item in account_type_list"
                          :key="item.id"
                          :label="item.account_type_name"
                          :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <span v-if="$v.account_type_selected.$dirty && !$v.account_type_selected.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                    <el-input type="text" class="input card-number" placeholder="Description" v-model="description" />
                  </div>
                </div>
                <div class="input-field col s6">
                  <input
                    id="balance"
                    v-model.trim="balance"
                    type="text"
                    :class="{
                      error: $v.balance.$dirty && !$v.balance.required ||
                             $v.balance.$dirty && !$v.balance.decimal

                    }"
                  >
                  <label for="balance">Balance</label>
                  <span v-if="$v.balance.$dirty && !$v.balance.required" class="helper-text" data-error="wrong" >The field must be filled</span>
                  <span v-if="$v.balance.$dirty && !$v.balance.decimal" class="helper-text" data-error="wrong" >The field should contain only numbers</span>
                </div>
              </div>
            </div>

            <button
              class="btn waves-effect waves-light"
              type="submit"
              name="action"
            >
              Registration
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {required, decimal} from "vuelidate/lib/validators";

  export default {
    name: "addAccounts",
    validations: {
      balance: {required, decimal},
      min_balance: {required, decimal},
      user_selected: {required},
      currency_selected: {required},
      agent_selected: {required},
      account_type_selected: {required},
    },
    mounted() {
      let cast = Promise.resolve(this.$store.dispatch('request', {
        path: 'admin/gets/fulls/params/fors/accounts',
        dody: {}
      }));
      var vm = this;
      cast.then(function (v) {
        vm.user_list = v.user;
        vm.agent_list = v.agent;
        vm.account_type_list = v.account_type;
        vm.currency_list = v.currency;
      });
    },
    data: () => ({
      message: '',
      user_list: null,
      user_selected: null,
      agent_list: null,
      agent_selected: null,
      account_type_list: null,
      account_type_selected: null,
      currency_list: null,
      currency_selected: null,
      description: null,
      min_balance: '',
      balance: ''
    }),
    methods: {
      async onSubmitAdd() {
        if (this.$v.$invalid) {
          this.$v.$touch();
          return;
        }
        let answer = await this.$store.dispatch('request', {
          path: 'admin/adds/accounts', body: {
            user_id: this.user_selected,
            agent: this.agent_selected,
            account_type: this.account_type_selected,
            currency: this.currency_selected,
            min_balance: this.min_balance,
            balance: this.balance,
            description: this.description,
          }
        });

        if (answer.message && answer.message === 'ok') {
          this.message = "Account is Created";
          this.currency = '';
          this.account_type = '';
          this.min_balance = '';
          this.balance = '';
        } else {
          this.message = "Account is NOT created";
        }
      }
    },
    updated() {
      window.M.FormSelect.init(this.$refs.user_selected);
      window.M.FormSelect.init(this.$refs.agent_selected);
      window.M.FormSelect.init(this.$refs.account_type_selected);
      window.M.FormSelect.init(this.$refs.currency_selected);
    },
  }
</script>

<style lang="scss" scoped>
  .input-field .helper-text {
    color: red;
  }

  .card-number {
    margin-top: 40px;
  }

  .select {
    width: 100%;
    color: #000;
  }
</style>
